import { type LineItemType } from "legacyComponents/LineItemContainer.types";

import yup from "utilities/form/yup";

import { type ILineItemRow } from "commonComponents/utilities/LineItemContainer/types/LineItem.interfaces";
import {
    baseLineItemSchemaDefinition,
    markupLineItemSchemaDefinition,
    taxLineItemSchemaDefinition,
} from "commonComponents/utilities/LineItemContainer/types/LineItem.schemas";
import {
    type IBaseLineItem,
    type IMarkupLineItem,
    type ITaxLineItem,
} from "commonComponents/utilities/LineItemContainer/types/LineItem.types";

import { type ILineItemRelatedItem } from "entity/hawk/api/lineItem.api.types";

export interface ISelectionChoiceLineItem extends IMarkupLineItem, ILineItemRow, ITaxLineItem {
    isTBD: boolean;
    quantity: number;
}

export interface ISelectionOptionLineItem extends IMarkupLineItem, ILineItemRow, ITaxLineItem {
    quantity: number;
    isTBD: boolean;
    lineItemType: LineItemType;
    costCodeTitle: string | null;
    relatedItems?: ILineItemRelatedItem[];
}

const baseLineItemSelectionChoiceSchemaType = {
    ...baseLineItemSchemaDefinition,
    ...markupLineItemSchemaDefinition,
    ...taxLineItemSchemaDefinition,
    isTBD: yup.boolean().label("Set Price Later"),
};
const baseLineItemSelectionOptionSchemaType = {
    ...baseLineItemSchemaDefinition,
    ...markupLineItemSchemaDefinition,
    ...taxLineItemSchemaDefinition,
};

type BaseLineItemSelectionChoiceSchemaType = typeof baseLineItemSelectionChoiceSchemaType;
type BaseLineItemSelectionOptionSchemaType = typeof baseLineItemSelectionOptionSchemaType;

export function getLineItemSelectionChoicesSchema(
    getExtendedSchema: (
        baseSchema: BaseLineItemSelectionChoiceSchemaType,
    ) => BaseLineItemSelectionChoiceSchemaType = (s) => s,
) {
    return yup.object<IBaseLineItem>(getExtendedSchema(baseLineItemSelectionChoiceSchemaType));
}

export function getLineItemSelectionOptionsSchema(
    getExtendedSchema: (
        baseSchema: BaseLineItemSelectionOptionSchemaType,
    ) => BaseLineItemSelectionOptionSchemaType = (s) => s,
) {
    return yup.object<IBaseLineItem>(getExtendedSchema(baseLineItemSelectionOptionSchemaType));
}
